import { INIT_PAGE_STATE } from "../../../constants/constants";

export const LOAD_MASTER_DOCUMENT_LIST = "LOAD_MASTER_DOCUMENT_LIST";
export const LOAD_MASTER_DOCUMENT_LIST_SUCCESS =
  "LOAD_MASTER_DOCUMENT_LIST_SUCCESS";
export const LOAD_MASTER_DOCUMENT_LIST_ERROR = "LOAD_MASTER_DOCUMENT_LIST_ERROR";

export const ADDEDIT_MASTER_DOCUMENT = "ADDEDIT_MASTER_DOCUMENT";
export const ADDEDIT_MASTER_FORM_FIELD_DOCUMENT = "ADDEDIT_MASTER_FORM_FIELD_DOCUMENT";
export const SAVE_ADDEDIT_MASTER_DOCUMENT = "SAVE_ADDEDIT_MASTER_DOCUMENT";
export const SAVE_ADDEDIT_MASTER_DOCUMENT_SUCCESS =
  "SAVE_ADDEDIT_MASTER_DOCUMENT_SUCCESS";
export const SAVE_ADDEDIT_MASTER_DOCUMENT_ERROR =
  "SAVE_ADDEDIT_MASTER_DOCUMENT_ERROR";
export const CLOSE_ADDEDIT_MASTER_DOCUMENT = "CLOSE_ADDEDIT_MASTER_DOCUMENT";
export const CLOSE_ADDEDIT_MASTER_FORM_FIELD_DOCUMENT = "CLOSE_ADDEDIT_MASTER_FORM_FIELD_DOCUMENT";

export const DELETE_MASTER_DOCUMENT = "DELETE_MASTER_DOCUMENT";
export const DELETE_MASTER_DOCUMENT_SUCCESS = "DELETE_MASTER_DOCUMENT_SUCCESS";
export const DELETE_MASTER_DOCUMENT_ERROR = "DELETE_MASTER_DOCUMENT_ERROR";

export const loadMasterDocumentList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      orderBy: "id",
      sortedBy: "asc",
      limit: INIT_PAGE_STATE.pageSizes[0],
    },
    ...p,
  };
  return {
    type: LOAD_MASTER_DOCUMENT_LIST,
    payload: {
      selectedPage: param.selectedPage,
      filter: param.filter,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
    },
  };
};

export const loadMasterDocumentListSuccess = (data) => ({
  type: LOAD_MASTER_DOCUMENT_LIST_SUCCESS,
  payload: data,
});

export const loadMasterDocumentListError = (error) => ({
  type: LOAD_MASTER_DOCUMENT_LIST_ERROR,
  payload: error,
});

export const addeditMasterDocument = (item, mode = "add") => ({
  type: ADDEDIT_MASTER_DOCUMENT,
  payload: {
    item,
    mode,
  },
});

export const addeditMasterFormFieldDocument = (item, mode = "add") => ({
  type: ADDEDIT_MASTER_FORM_FIELD_DOCUMENT,
  payload: {
    item,
    mode,
  },
});

export const closeAddeditMasterDocument = () => ({
  type: CLOSE_ADDEDIT_MASTER_DOCUMENT,
});

export const closeAddeditMasterFormFieldDocument = () => ({
  type: CLOSE_ADDEDIT_MASTER_FORM_FIELD_DOCUMENT,
});

export const saveAddeditMasterDocument = (item, mode = "add") => ({
  type: SAVE_ADDEDIT_MASTER_DOCUMENT,
  payload: {
    item,
    mode,
  },
});

export const saveAddeditMasterDocumentSuccess = (data) => ({
  type: SAVE_ADDEDIT_MASTER_DOCUMENT_SUCCESS,
  payload: data,
});

export const saveAddeditMasterDocumentError = (error) => ({
  type: SAVE_ADDEDIT_MASTER_DOCUMENT_ERROR,
  payload: error,
});

export const deleteMasterDocument = (data, confirmed = false) => ({
  type: DELETE_MASTER_DOCUMENT,
  payload: {
    item: data,
    confirmed,
  },
});

export const deleteMasterDocumentSuccess = () => ({
  type: DELETE_MASTER_DOCUMENT_SUCCESS,
});

export const deleteMasterDocumentError = (error) => ({
  type: DELETE_MASTER_DOCUMENT_ERROR,
  payload: error,
});
